module.exports = __webpack_public_path__ + "static/media/RN.1ab0ee1e.jpg";